import Inbox from '@/pages/requests/InboxPage.vue'
// import DirectDebitSentboxPage from '@/pages/services/directDebit/SendboxPage.vue'
import DetailPage from '@/pages/requests/detailPages/DirectDebitDetailPage.vue'
import CreationPage from '@/pages/requests/creationPages/capsules/TDirectDebitCreate.vue'
import ContactDebtorList from '@/pages/requests/ContactDebtorList.vue'
import DirectDebitDraftCreate from '@/pages/services/directDebit/TDraftCreate.vue'
import DirectDebitDraftEdit from '@/pages/services/directDebit/TDraftEdit.vue'
import DirectDebitDraft from '@/pages/services/directDebit/DDDraftPage.vue'
import DirectDebitPilotage from '@/pages/statistics/StatisticsPage.vue'

export default [
  {
    path: '/inbox/',
    alias: [],
    component: Inbox
  },
  /* {
    path: '/directDebit/sendbox/',
    alias: [],
    component: DirectDebitSentboxPage
  }, */
  {
    path: '/directDebit/details/:direction/',
    alias: [],
    component: DetailPage
  },
  {
    path: '/directDebit/creation/',
    alias: [],
    component: CreationPage
  },
  {
    path: '/directDebit/draft',
    component: DirectDebitDraft
  },
  {
    path: '/directDebit/draft/edit/',
    component: DirectDebitDraftEdit
  },
  {
    path: '/directDebit/draft/create/',
    component: DirectDebitDraftCreate
  },
  {
    path: '/directDebit/contactDebtorList/',
    alias: ['/account/createPayments/contactDebtorList', '/createPayments/contactDebtorList/'],
    component: ContactDebtorList
  },
  {
    path: '/directDebit/pilotage',
    component: DirectDebitPilotage
  }
]



// WEBPACK FOOTER //
// ./src/routes/services/directDebit.js